import { useMemo } from 'react';
import { hasUserPermissions } from '../../helpers/utils/permissoes';

export const PERMISSAO_GERENCIAR_DASHBOARD = 1401;

/**
 * Gate de permissão dos botões de edição da Home (Calendário/Mural de Avisos).
 * Compartilhado entre `CalendarioCard` e `MuralAvisosCard` — mesmo critério do
 * `AtualizarMuralDashboard` real (permissão 1401, `dashboardGerenciar`).
 *
 * Recalcula quando a permissão do usuário logado mudar durante a sessão —
 * `hasUserPermissions` lê o store diretamente, então sem essa dependência o
 * `useMemo` travaria no snapshot da primeira renderização.
 *
 * Gate apenas cosmético — os endpoints reais são quem validam a permissão de
 * fato.
 */
export default function usePodeGerenciarDashboard() {
  return useMemo(
    () => hasUserPermissions(PERMISSAO_GERENCIAR_DASHBOARD),
    [],
  );
}
